<div class="container-fluid glb-popup">
  <h2> {{formTitle}}</h2>
  <p-toast [style]="{marginTop: '80px'}">
  </p-toast>
  <p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

  <button mat-icon-button [mat-dialog-close]="true" style="float:right;top:-50px;background-color: transparent;">
    <i class="pi pi-times" aria-hidden="true"></i>
  </button>
  <hr>
    <div [formGroup]="form1" class="forms w-100 d-block">

      <div class="row m-0">

        <div class="col-lg-12">
          @if (formAlert) {
            <div class="w-100 mb-3">
              <div class="w-100"
                style="text-align: center; background-color: yellow;padding:5px;margin-bottom:15px;">
                <p><b>{{formAlert}}</b></p>
              </div>
            </div>
          }
        </div>

        <div class="col-lg-6">
          <span class="p-float-label w-100 mb-3">
            <p-dropdown class="w-100" [options]="locations" formControlName="locationId" optionLabel="name"
            optionValue="value" placeholder="locationId"></p-dropdown>
            <label for="locationId">locationId</label>
            @for (validation of validationMessages.locationId; track validation) {
              <span>
                @if (form1.get('locationId').hasError(validation.type) && (form1.get('locationId').dirty || form1.get('locationId').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-6">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="title" id="title" type="text" pInputText>
            <label for="title">Title</label>
            @for (validation of validationMessages.title; track validation) {
              <span>
                @if (form1.get('title').hasError(validation.type) && (form1.get('title').dirty || form1.get('title').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-6">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="description" id="description" type="text" pInputText>
            <label for="description">Description</label>
            @for (validation of validationMessages.description; track validation) {
              <span>
                @if (form1.get('description').hasError(validation.type) && (form1.get('description').dirty || form1.get('description').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <!-- <div class="col-lg-6">
        <span class="p-float-label w-100 mb-3">
          <p-dropdown class="w-100" [options]="statuses" formControlName="category" optionLabel="name"
          optionValue="value" placeholder="Category"></p-dropdown>
          <label for="Category">Category</label>
          <span *ngFor="let validation of validationMessages.category">
            <small class="p-invalid"
              *ngIf="form1.get('category').hasError(validation.type) && (form1.get('category').dirty || form1.get('category').touched)">{{validation.message}}
            </small>
          </span>
        </span>
      </div> -->

      <div class="col-lg-6">
        <span class="p-float-label w-100 mb-3">
          <p-dropdown class="w-100" [options]="codes" formControlName="svcCode" optionLabel="name"
          optionValue="value" placeholder="Service Code"></p-dropdown>
          <label for="Service Code">Service Code</label>
          @for (validation of validationMessages.svcCode; track validation) {
            <span>
              @if (form1.get('svcCode').hasError(validation.type) && (form1.get('svcCode').dirty || form1.get('svcCode').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>

      <div class="col-lg-6">
        <span class="p-float-label w-100 mb-3">
          <p-dropdown class="w-100" [options]="listingStatus" formControlName="listingStatus" optionLabel="name"
          optionValue="value" placeholder="Listing Status"></p-dropdown>
          <label for="Listing Status">Listing Status</label>
          @for (validation of validationMessages.listingStatus; track validation) {
            <span>
              @if (form1.get('listingStatus').hasError(validation.type) && (form1.get('listingStatus').dirty || form1.get('listingStatus').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>

      <div class="col-lg-6">
        <span class="p-float-label w-100 mb-3">
          <p-dropdown class="w-100" [options]="categories" formControlName="svcCategory" optionLabel="name"
          optionValue="value" placeholder="Service Category"></p-dropdown>
          <label for="Service Category">Service Category</label>
          @for (validation of validationMessages.svcCategory; track validation) {
            <span>
              @if (form1.get('svcCategory').hasError(validation.type) && (form1.get('svcCategory').dirty || form1.get('svcCategory').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>


      <div class="col-lg-6">
        <span class="p-float-label required-field w-100 mb-3">
          <input formControlName="itemPurchPrice" id="itemPurchPrice" type="number" pInputText>
          <label for="itemPurchPrice">Item Purchase Price</label>
          @for (validation of validationMessages.itemPurchPrice; track validation) {
            <span>
              @if (form1.get('itemPurchPrice').hasError(validation.type) && (form1.get('itemPurchPrice').dirty || form1.get('itemPurchPrice').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>

      <div class="col-lg-6">
        <span class="p-float-label required-field w-100 mb-3">
          <input formControlName="itemResalePrice" id="itemResalePrice" type="number" pInputText>
          <label for="itemResalePrice">Item Resale Price</label>
          @for (validation of validationMessages.itemResalePrice; track validation) {
            <span>
              @if (form1.get('itemResalePrice').hasError(validation.type) && (form1.get('itemResalePrice').dirty || form1.get('itemResalePrice').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>

      <div class="col-lg-6">
        <span class="p-float-label required-field w-100 mb-3">
          <input formControlName="svcPurchPrice" id="svcPurchPrice" type="number" pInputText>
          <label for="svcPurchPrice">Svc Purchase Price</label>
          @for (validation of validationMessages.svcPurchPrice; track validation) {
            <span>
              @if (form1.get('svcPurchPrice').hasError(validation.type) && (form1.get('svcPurchPrice').dirty || form1.get('svcPurchPrice').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>

      <div class="col-lg-6">
        <span class="p-float-label required-field w-100 mb-3">
          <input formControlName="svcResalePrice" id="svcResalePrice" type="number" pInputText>
          <label for="svcResalePrice">Svc Resale Price</label>
          @for (validation of validationMessages.svcResalePrice; track validation) {
            <span>
              @if (form1.get('svcResalePrice').hasError(validation.type) && (form1.get('svcResalePrice').dirty || form1.get('svcResalePrice').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>

      <div class="col-lg-6">
        <span class="p-float-label required-field w-100 mb-3">
          <input formControlName="defaultSvcMins" id="defaultSvcMins" type="number" pInputText>
          <label for="defaultSvcMins">Default Svc Mins</label>
          @for (validation of validationMessages.defaultSvcMins; track validation) {
            <span>
              @if (form1.get('defaultSvcMins').hasError(validation.type) && (form1.get('defaultSvcMins').dirty || form1.get('defaultSvcMins').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>

      <div class="col-lg-6">
        <span class="p-float-label required-field w-100 mb-3">
          <input formControlName="defaultSvcRate" id="defaultSvcRate" type="number" pInputText>
          <label for="defaultSvcRate">Default Svc Rate</label>
          @for (validation of validationMessages.defaultSvcRate; track validation) {
            <span>
              @if (form1.get('defaultSvcRate').hasError(validation.type) && (form1.get('defaultSvcRate').dirty || form1.get('defaultSvcRate').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>

      <div class="col-lg-12">
        <span class="p-float-label w-100 mb-3">
          <textarea formControlName="opsNotes" id="opsNotes" [rows]="2" pInputTextarea></textarea>
          <label for="opsNotes">Ops Notes</label>
          @for (validation of validationMessages.opsNotes; track validation) {
            <span>
              @if (form1.get('opsNotes').hasError(validation.type) && (form1.get('opsNotes').dirty || form1.get('opsNotes').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>

      <div class="col-lg-12">
        <span class="p-float-label w-100 mb-3">
          <textarea formControlName="publicNotes" id="publicNotes" [rows]="2" pInputTextarea></textarea>
          <label for="publicNotes">Public Notes</label>
          @for (validation of validationMessages.publicNotes; track validation) {
            <span>
              @if (form1.get('publicNotes').hasError(validation.type) && (form1.get('publicNotes').dirty || form1.get('publicNotes').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>

    </div>
  </div>

  <hr>

    <div class="row m-0">
      <div class="col-lg-12">
        <div class="btn-group">
          <div class="button-group">
            @if (serviceProductId) {
              <button pButton class="btn-delete p-button-outlined p-button-danger"
              (click)="onFormDelete()">Delete Service Product</button>
            }
          </div>

          <div class="button-group">
            <button pButton class="btn-cancel p-button-text" [mat-dialog-close]="true">Cancel</button>
            @if (!serviceProductId) {
              <button pButton class="btn-addt p-button" (click)="formAdd()">Add Service Product</button>
            }

            @if (serviceProductId) {
              <button pButton  class="btn-upt p-button" (click)="formUpdate()">Update Service Product</button>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
